import { render, staticRenderFns } from "./SichernConnectBody.vue?vue&type=template&id=00350138&scoped=true"
import script from "./SichernConnectBody.vue?vue&type=script&lang=js"
export * from "./SichernConnectBody.vue?vue&type=script&lang=js"
import style0 from "./SichernConnectBody.vue?vue&type=style&index=0&id=00350138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00350138",
  null
  
)

export default component.exports